import { writable } from 'svelte/store';

const COOKIE_NAME = 'custom_reviews';
const COOKIE_DAYS = 365;

function readCookie() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
  return match ? match[1] === 'true' : false;
}

function writeCookie(value) {
  const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  document.cookie = `${COOKIE_NAME}=${value}; expires=${expires}; path=/; SameSite=Strict`;
}

// Initialise from cookie on first import
const { subscribe, set } = writable(readCookie());

export const customReviewsEnabled = { subscribe };

export function setCustomReviewsEnabled(value) {
  writeCookie(value);
  set(value);
}
